import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsIconModule, CmpsScrollbarModule } from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { EventBoxComponent } from './event-box.component';

@NgModule({
    imports: [
        CmpsIconModule,
        CmpsLazyI18nModule,
        CmpsScrollbarModule,
        CommonModule,
    ],
    declarations: [EventBoxComponent],
    exports: [EventBoxComponent],
})
export class CmpsEventBoxModule {}
